import React from 'react'
import PropTypes from 'prop-types'
import ReactDOM from 'react-dom'
import Arrow from './Arrow'

let popoverContainer = null

export class PopoverContainer extends React.Component {
  componentDidMount() {
    popoverContainer = this.container
  }
  componentWillUnmount() {
    popoverContainer = null
  }
  getWrappedInstance = () => {
    return this.container
  }
  render() {
    return (
      <div
        className="aspect-ratio--object z-9999 pointer-events-none"
        ref={(el) => {
          this.container = el
        }}
      />
    )
  }
}

export default class Popover extends React.Component {
  handleOverlayClick = (event) => {
    event.stopPropagation()
    event.preventDefault()
    this.props.onClose(event)
  }
  render() {
    const {
      padding,
      maxWidth,
      source,
      visible,
      arrowSize,
      offsetX,
      offsetY,
    } = this.props
    const sourceBounds = source && source.getBoundingClientRect()
    const { x, y } = sourceBounds
      ? {
          x: Math.round(sourceBounds.left + sourceBounds.width / 2),
          y: Math.round(sourceBounds.top + sourceBounds.height),
        }
      : this.props
    const ww = window.innerWidth
    const wh = window.innerHeight

    const minArrowMarginX = Math.max(arrowSize, padding)

    // x position limited by window width, window padding, and arrow size
    // (position the arrow will point to)
    const arrowX = Math.max(
      minArrowMarginX,
      Math.min(x + offsetX, ww - minArrowMarginX)
    )
    // popover width
    const width = Math.min(ww - padding * 2, maxWidth)

    // x position of the popover box, limited by the popover width and window padding
    const boxX = Math.max(
      padding,
      Math.min(ww - width - padding, x + offsetX - width / 2)
    )

    const targetY = y + offsetY
    const maxHeight = wh - targetY - arrowSize - padding
    const popover = (
      <React.Fragment>
        <div
          className={`aspect-ratio--object bg-black ${
            visible ? 'o-20 pointer-events-all' : 'o-0 pointer-events-none'
          }
          `}
          id="popover-overlay"
          style={{
            transition: 'opacity 100ms',
          }}
          onClick={this.handleOverlayClick}
        />
        <div
          className={`absolute left-0 z-9999 ${
            visible ? 'o-100 pointer-events-all' : 'o-0 pointer-events-none'
          }`}
          style={{
            top: targetY,
            transformOrigin: `${arrowX}px 0`,
            transform: visible
              ? 'translate3d(0,0,0) scale(1,1)'
              : 'translate3d(0,0,0) scale(0.7,0.7)',
            transition:
              'transform 150ms cubic-bezier(0.23, 1, 0.32, 1), opacity 50ms',
          }}
        >
          <div
            className="absolute bg-base br3 pa4"
            style={{
              top: arrowSize,
              left: boxX,
              width,
              boxShadow: '1px 10px 20px 8px rgba(0,0,0,0.2)',
              maxHeight,
              overflow: 'auto',
            }}
          >
            {this.props.children}
          </div>
          <Arrow size={arrowSize} x={arrowX} />
        </div>
      </React.Fragment>
    )

    if (!popoverContainer) return popover

    return ReactDOM.createPortal(popover, popoverContainer)
  }
}

Popover.propTypes = {
  children: PropTypes.node,
  visible: PropTypes.bool,
  source:
    typeof Element !== 'undefined'
      ? PropTypes.instanceOf(Element)
      : PropTypes.object,
  x: PropTypes.number,
  y: PropTypes.number,
  offsetX: PropTypes.number,
  offsetY: PropTypes.number,
  onClose: PropTypes.func,
  padding: PropTypes.number,
  maxWidth: PropTypes.number,
  arrowSize: PropTypes.number,
}

Popover.defaultProps = {
  padding: 10,
  maxWidth: 300,
  arrowSize: 14,
  x: 0,
  y: 0,
  offsetX: 0,
  offsetY: 0,
}
